import { render, staticRenderFns } from "./CoreProducts.vue?vue&type=template&id=1c5674e4&scoped=true"
import script from "./CoreProducts.vue?vue&type=script&lang=js"
export * from "./CoreProducts.vue?vue&type=script&lang=js"
import style0 from "./CoreProducts.vue?vue&type=style&index=0&id=1c5674e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5674e4",
  null
  
)

export default component.exports